// extracted by mini-css-extract-plugin
export default {"grid":"Section_grid__YxJOV","hoverScale":"Section_hoverScale__Ms4Tp"};